import styled from '@mui/material/styles/styled';
import { Input, inputClasses, } from '@mui/material';
var StandardInput = styled(Input)(function (_a) {
    var _b;
    var theme = _a.theme, color = _a.color;
    return _b = {
            backgroundColor: '#FFF'
        },
        _b["&:hover:not(." + inputClasses.disabled + "):before"] = {
            borderBottom: "1px solid rgba(0,0,0,0.26)",
        },
        _b['&:after'] = {
            borderBottom: "1px solid " + theme.palette.primary.main,
        },
        _b['&:before'] = {
            borderBottom: "1px solid rgba(0,0,0,0.08)",
        },
        _b;
});
export default StandardInput;
